<template>
  <div class="warehouseDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <van-field :label="$t.warehouse.warehouseLogo">
        <template #input>
          <van-uploader v-model="warehouseLogo" :max-count="1" :after-read="afterRead1" />
        </template>
      </van-field>

      <van-field
        v-model="form.WarehouseName"
        :label="$t.warehouse.warehouseName"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.WarehouseNumber"
        :label="$t.warehouse.warehouseNumber"
        disabled
        v-if="form.WarehouseNumber"
      />

      <div class="warehouseDetail-radio">
        <div class="radio-label">{{ $t.warehouse.warehouseOwnership }}</div>
        <van-radio-group v-model="form.WarehouseOwnership" direction="horizontal">
          <van-radio :name="1">{{ $t.warehouse.ownerOption1 }}</van-radio>
          <van-radio :name="2">{{ $t.warehouse.ownerOption2 }}</van-radio>
        </van-radio-group>
      </div>

      <van-field
        clickable
        readonly
        :value="selectedWarehouseKeeper.text"
        :label="$t.warehouse.warehouseKeeper"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showWarehouseDetailKeeper')"
      />

      <div class="custom-date">
        <div class="date-label">{{ $t.warehouse.warehouseTime }}</div>
        <div class="date-btn1" @click="showStartDate">
          <span v-if="beginTime">{{ beginTime }}</span>
          <span v-else>{{ $t.meta.beginDate }}</span>
        </div>
        <div class="date-btn2" @click="showEndDate">
          <span v-if="endTime">{{ endTime }}</span>
          <span v-else>{{ $t.meta.endDate }}</span>
        </div>
      </div>

      <van-field
        v-model="form.WarehouseAddress"
        :label="$t.warehouse.warehouseAddress"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="5"
      />

      <van-field
        v-model="form.PrecautionsForWarehousing"
        :label="$t.warehouse.precaution"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="5"
      />

      <van-field
        clickable
        readonly
        :value="selectedCountry.text"
        :label="$t.meta.country"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showWarehouseDetailCountry')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="selectedCity.text"
        :label="$t.meta.city"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showWarehouseDetailCity')"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.WarehouseContactPhone"
        :label="$t.warehouse.warehousePhone"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.WarehouseContactEmail"
        :label="$t.warehouse.warehouseEmail"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.WarehouseContact1"
        :label="$t.warehouse.warehouseContact1"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.WarehouseContact2"
        :label="$t.warehouse.warehouseContact2"
        :placeholder="$t.meta.input"
      />

      <div class="warehouseDetail-radio">
        <div class="radio-label">{{ $t.warehouse.warehouseOption1 }}</div>
        <van-radio-group v-model="form.WarehouseTypeId" direction="horizontal">
          <van-radio
            v-for="(item, index) in warehouseOptions1"
            :key="index"
            :name="item.WTId"
            >{{ item.TypeName }}</van-radio
          >
        </van-radio-group>
      </div>

      <div class="warehouseDetail-checkbox">
        <div class="checkbox-label">{{ $t.warehouse.warehouseOption2 }}</div>
        <van-checkbox-group v-model="warehouseTypes" direction="horizontal">
          <van-checkbox
            v-for="(item, index) in warehouseOptions2"
            :key="index"
            :name="item.WTId"
            >{{ item.TypeName }}</van-checkbox
          >
        </van-checkbox-group>
      </div>

      <div class="title">{{ $t.warehouse.ties }}</div>

      <div class="warehouseDetail-checkbox">
        <van-checkbox style="margin: 0" v-model="form.IsExternalUndertakingService">{{
          $t.warehouse.isService
        }}</van-checkbox>
      </div>

      <template v-if="form.IsExternalUndertakingService">
        <van-field
          v-model="form.Contacts"
          :label="$t.warehouse.contact"
          :placeholder="$t.meta.input"
        />

        <van-field
          v-model="form.ContactNumber"
          :label="$t.warehouse.phone"
          :placeholder="$t.meta.input"
        />
      </template>

      <div class="multi-table" v-if="form.WarehouseFileList">
        <van-field name="stepper" :label="$t.warehouse.warehousePhoto">
          <template #input>
            <van-stepper
              :min="0"
              :value="form.WarehouseFileList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.WarehouseFileList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="$t.warehouse.photo + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.FilePath))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                native-type="button"
                v-if="item.FilePath"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader :after-read="afterRead2" @click-upload="uploaderClick(index)">
                <van-image
                  :src="item.FilePath && imgUrlFilter(item.FilePath)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.FilePath"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  native-type="button"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <div class="tool-bar">
        <van-button type="info" block native-type="submit">{{ $t.meta.save }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="time"
        :title="$t.warehouse.startDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="time"
        :title="$t.warehouse.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
      />
    </van-popup>

    <option-list
      event="showWarehouseDetailKeeper"
      :options="employeeList"
      @onSelect="onSelectKeeper"
    ></option-list>

    <option-list
      event="showWarehouseDetailCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showWarehouseDetailCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Uploader,
  Stepper,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Uploader)
  .use(Stepper);

export default {
  name: "warehouseDetail",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isEdit: false,
      whid: "",
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      warehouseLogo: [],
      selectedCountry: { text: "", value: null },
      selectedCity: { text: "", value: null },
      selectedWarehouseKeeper: { text: "", value: null },
      warehouseTypes: [],
      filesIndex: 0,
      //日期
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //选项
      employeeList: [],
      countryList: [],
      cityList: [],
      warehouseOptions1: [],
      warehouseOptions2: [],
    };
  },
  created() {
    const { WHId, IsEdit } = this.$route.query;
    this.isEdit = IsEdit;
    if (IsEdit) {
      this.whid = WHId;
      this.getOptions().then((success) => {
        if (success) {
          if (WHId) this.getWarehouseManagementDetail();
        }
      });
    } else {
      this.form = {
        EMId: "",
        WHId: "",
        WarehouseName: "",
        WarehouseOwnership: 1,
        Warehouse: { value: "" },
        WarehouseLogo: "",
        CountryId: "",
        CityId: "",
        WarehouseAddress: "",
        WarehouseContact1: "",
        WarehouseContact2: "",
        WarehouseContactPhone: "",
        WarehouseContactEmail: "",
        WarehouseOperationTime: "",
        WarehouseTypeId: "1",
        WarehouseDetailList: [],
        PrecautionsForWarehousing: "",
        IsExternalUndertakingService: 0,
        Contacts: "",
        ContactNumber: "",
        WarehouseFileList: [],
      };
      this.getOptions();
    }
  },
  methods: {
    handleDelByIndex(index) {
      if (this.form.WarehouseFileList.length > 0) {
        this.form.WarehouseFileList.splice(index, 1);
      }
    },
    handleDel() {
      if (this.form.WarehouseFileList.length > 0) {
        this.form.WarehouseFileList.pop();
      }
    },
    handleAdd() {
      this.form.WarehouseFileList.push({
        FilePath: "",
      });
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "hour") {
        return val;
      }
      if (type === "minute") {
        return val;
      }
      return val;
    },
    dateChange(date, type) {
      if (type == "start") {
        this.beginTime = date;
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = date;
        this.showEndPicker = false;
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getWarehouseManagementDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          WHId: this.whid,
        };
        this.$api.storage
          .getWarehouseManagementDetail(param)
          .then((res) => {
            this.form = res.data;
            //图标
            if (this.form.WarehouseLogo) {
              this.warehouseLogo.push({
                url: this.imgUrlFilter(this.form.WarehouseLogo),
              });
            }
            //仓库多选
            var checkbox = this.formatData(this.form.WarehouseDetailList, true);
            this.form.WarehouseDetailList = checkbox;
            this.warehouseTypes = checkbox;
            //日期
            if (this.form.WarehouseOperationTime) {
              this.beginTime = this.form.WarehouseOperationTime.split("-")[0];
              this.endTime = this.form.WarehouseOperationTime.split("-")[1];
            }
            //仓库管理员
            var warehouseKeeper = this.employeeList.find(
              (c) => c.value == this.form.EMId
            );
            if (warehouseKeeper) {
              this.selectedWarehouseKeeper.text = warehouseKeeper.text;
              this.selectedWarehouseKeeper.value = warehouseKeeper.value;
            }
            //国家
            var country = this.countryList.find((c) => c.value == this.form.CountryId);
            if (country) {
              this.selectedCountry.text = country.text;
              this.selectedCountry.value = country.value;
            }
            //城市
            var city = this.cityList.find((c) => c.value == this.form.CityId);
            if (city) {
              this.selectedCity.text = city.text;
              this.selectedCity.value = city.value;
            }
            //对外承接
            if (this.form.IsExternalUndertakingService == "1") {
              this.form.IsExternalUndertakingService = true;
            } else {
              this.form.IsExternalUndertakingService = false;
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    formatData(ids, isDetail) {
      let result = [];
      if (isDetail) {
        for (let id of ids) {
          if (id.WTId) {
            result.push(id.WTId);
          }
        }
      } else {
        for (let id of ids) {
          result.push({
            WTId: id,
          });
        }
      }
      return result;
    },
    onSelectKeeper(item) {
      this.selectedWarehouseKeeper.text = item.text;
      this.selectedWarehouseKeeper.value = item.value;
    },
    onSelectCountry(item) {
      this.selectedCountry.text = item.text;
      this.selectedCountry.value = item.value;
    },
    onSelectCity(item) {
      this.selectedCity.text = item.text;
      this.selectedCity.value = item.value;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.EMId = this.selectedWarehouseKeeper.value;
      param.CountryId = this.selectedCountry.value;
      param.CityId = this.selectedCity.value;
      param.WarehouseOperationTime = this.beginTime + "-" + this.endTime;
      param.WarehouseDetailList = this.formatData(this.warehouseTypes, false);
      param.IsExternalUndertakingService = this.form.IsExternalUndertakingService ? 1 : 0;
      param.CompanyId = this.CompanyId;
      var request = null;
      if (this.isEdit) {
        request = this.$api.storage.editWarehouseManagement(param);
      } else {
        request = this.$api.storage.addWarehouseManagement(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.WarehouseLogo = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead2(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.WarehouseFileList[this.filesIndex].FilePath = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    getOptions() {
      return new Promise((resolve) => {
        Promise.all([
          this.getExpressEmployeeList(),
          this.getWarehouseTypeList(),
          this.getCountryList(),
          this.getCityList(),
        ]).then((success) => {
          if (success) resolve(true);
        });
      });
    },
    getExpressEmployeeList() {
      return new Promise((resolve) => {
        var param = {
          EmployeeRole: 3,
          IsLocked: 0,
        };
        this.$api.storage
          .getExpressEmployeeListByPage(param)
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.FullName + " , " + item.PhoneNumber,
                value: item.EMId,
              };
              result.push(data);
            });
            this.employeeList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getWarehouseTypeList() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.storage
          .getWarehouseTypeList()
          .then((res) => {
            var result1 = [];
            var result2 = [];
            res.data.forEach((item) => {
              if (item.IsMultipleSelect == 1) result2.push(item);
              else result1.push(item);
            });
            this.warehouseOptions1 = result1;
            this.warehouseOptions2 = result2;
            resolve(true);
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getCityList() {
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList({
            type: 1,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.City_cn + "," + item.City_en,
                value: item.Id,
              };
              result.push(data);
            });
            this.cityList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.warehouseDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
  .warehouseDetail-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .warehouseDetail-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .custom-date {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .date-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .date-btn1 {
      width: 47%;
      display: inline-block;
      border-right: 1px solid #ebedf0;
      vertical-align: middle;
      margin-right: 5%;
      font-size: 14px;
      color: #969799;
      text-align: center;
    }
    .date-btn2 {
      width: 47%;
      display: inline-block;
      vertical-align: middle;
      font-size: 14px;
      color: #969799;
      text-align: center;
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
